<template>
  <div class="manual-review">
    <el-drawer
      title="审核设置"
      :visible.sync="flag"
      direction="rtl"
      size="65%"
      :before-close="closeManualReview"
      :destroy-on-close="true"
    >
      <div class="overflow-y-auto" style="height: calc(100% - 65px)">
        <!-- 网调开关 -->
        <p class="p-6 pb-4 text-medium-x font-semibold text-theme-black-850 leading-22">需人工审核的答卷回收渠道</p>
        <div class="text-medium text-theme-black-650 leading-22 font-normal ml-6">
          <div class="mb-3">
            网络调查
            <el-switch class="ml-3" v-model="surveyFlag" @change="handlerSurveyFlag"></el-switch>
          </div>
          <div v-if="surveyFlag" class="bg-card-bg-gray mr-6 mb-6 px-4 py-3">
            <p class="text-yellow-theme leading-22 text-small">
              <i class="el-icon-warning-outline"></i>
              请务必在限定时间内完成数据审核，超时可能会导致无效数据被平台自动过审。
            </p>
            <el-radio v-model="auditRadio" label="enableAuditForRedEnvelopes" class="mt-3 text-opacity-65 mr-0">
              仅审核红包答卷，
            </el-radio>
            <el-select v-model="deadlineRed" placeholder="" class="bg-white-input" style="width: 64px">
              <el-option v-for="item in 3" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
            <span class="text-medium opacity-65">天内未审核由平台自动过审并发放红包。</span><br />
            <el-radio v-model="auditRadio" label="enableNetManualAudit" class="mt-3 text-opacity-65 mr-0">
              审核全部答卷，有红包的答卷
            </el-radio>
            <el-select v-model="deadlineAll" placeholder="" class="bg-white-input" style="width: 64px">
              <el-option v-for="item in 3" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
            <span class="text-medium opacity-65">天内未审核由平台自动过审并发放红包。</span>
          </div>
          <div class="mb-3">
            面对面访问
            <el-switch class="ml-3" disabled v-model="switchFlag"></el-switch>
          </div>
          <div class="mb-3">
            电话访问
            <el-switch class="ml-3" disabled v-model="switchFlag"></el-switch>
          </div>
          <div>
            委托代理
            <el-switch class="ml-3" disabled v-model="switchFlag"></el-switch>
          </div>
        </div>
        <p class="p-6 pb-4 pt-12 text-medium-x font-semibold text-theme-black-850 leading-22">审核流程设置</p>

        <!-- 审核设置的单选框 -->
        <template>
          <el-radio
            class="ml-6 text-medium text-theme-black-650 leading-22 font-normal mb-3"
            v-model="radio"
            :label="0"
            @change="singleReview"
          >
            单级审核
          </el-radio>
          <el-radio
            v-model="radio"
            :label="1"
            class="text-medium text-theme-black-650 leading-22 font-normal"
            @change="onClickOpenAudit"
          >
            多人多级审核
            <span class="text-small text-theme-black-450 leading-22 font-normal">
              （开启多人多级审核后，答卷数据页面也可对答卷进行审核）
            </span>
          </el-radio>
        </template>

        <!-- 卡片 -->
        <div class="bg-card-bg-gray mx-6 mb-6 px-4 pt-3 py-6" style="min-height: calc(100% - 332px)" v-if="radio && surveyFlag">
          <div v-if="companyId">
            <!-- 卡片的提示文字 -->
            <div class="text-medium leading-24 text-theme-black-450">
              <p class="text-theme-black-850">注意事项：</p>
              <p>1. 如未设置审核员，默认执行单级审核</p>
              <p>2. 存在多名审核员时，其中一名审核员同意或拒绝即可</p>
              <p>3. 当审核员中无人账号状态正常时，审核单将自动通过</p>
              <p>4. 如需调查员修改答卷后重新提交，请逐级驳回至调查员</p>
            </div>

            <!-- 审核层级表格 -->
            <ExamineTable
              v-for="(item, index) in examineTables"
              :key="item.levelId"
              :z-index="index + 1"
              :table-data="item.auditors"
              :disabled-add-user-btn="disabledAddUserBtn"
              @add-user="onClickAddUser(item, index)"
              @del-audit="onClickDelAudit(item, index)"
              @del-user="onClickDelUser(item, $event, index)"
            />
            <div class="text-center mt-5 flex w-full">
              <div class="h-px bg-ccc mt-4" style="width: calc(50% - 58px)"></div>
              <el-button class="mx-6" size="small" type="primary" @click="onClickAddLevel">添加审核层级</el-button>
              <div class="h-px bg-ccc mt-4" style="width: calc(50% - 58px)"></div>
            </div>
          </div>
          <div v-else>个人用户无法使用</div>
        </div>
      </div>

      <!-- 底部的提交按钮 -->
      <div class="py-4 border-t border-solid border-opacity-10 border-black flex justify-end pr-6">
        <span class="mr-3"><el-button size="small" @click="closeManualReview" class="normal-button">取消</el-button></span>
        <el-button size="small" type="primary" @click="saveSetting" class="normal-button">保存设置</el-button>
      </div>
    </el-drawer>

    <!-- 添加人员的弹窗 -->
    <AddAuditDialog
      :level-id="currentLevelId"
      :visible.sync="AddAuditDialogVisible"
      :company-id="companyId"
      :company-user="companyUser"
      :confirm-handler="confirmHandler"
      :select-user-list="currentLevelAuditors"
    />
  </div>
</template>

<script>
import ExamineTable from './components/ExamineTable'
import AddAuditDialog from './components/AddAuditDialog'
import GlobalConfig from '@/global/config.js'
import { transformLoadingFunction } from '@/assets/js/el-loading' //生成提示信息
import { getAudit, setAudit } from '@/api/wenjuan/multi-audit'
import { newGetDygcAllUser as getDygcAllUser } from '@/api/wenjuan/user'
import { saveSurveySetting, getFreeLink, changeLinkUrlState } from '@/api/wenjuan/publish.js'
// 底部按钮的引用
import { fixTask, overwriteLevels } from '@/api/wenjuan/multi-audit'
import { deepClone } from '@/assets/js/utils.js'

export default {
  name: 'ManualReview',
  components: { ExamineTable, AddAuditDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deadlineA: {
      type: Number,
      default: null
    },
    deadlineR: {
      type: Number,
      default: null
    },
    auditRa: {
      type: String,
      default: ''
    },
    peopleExamine: {
      type: Boolean
    },
    agentInt: {
      type: String,
      default: ''
    },
    peopleExa: {
      type: Boolean,
      default: false
    },
    preWj: Function,
    settings: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      flag: this.visible,
      switchFlag: true,
      surveyFlag: true,
      radio: 0,
      companyId: 0,
      surveyId: '',
      companyId: '',
      examineTables: [],
      examineTablesCopy: [],
      companyUser: null,
      disabledAddUserBtn: true, // 是否禁用添加用户按钮 请求用户数据慢的情况下先禁用 返回数据成功在启用
      currentLevelId: '',
      AddAuditDialogVisible: false,
      currentLevelAuditors: [],
      showOperaAudit: true, // 是否显示底部按钮
      isAddLevel: false,
      auditRadio: '',
      deadlineRed: 2,
      deadlineAll: 2
    }
  },
  methods: {
    // 答卷审核-第四部分
    handlerpeopleExamine() {
      saveSurveySetting(this.getParams())
        .then(res => {
          if (res.data.code !== 0) {
            return
          }
          if (this.settings) {
            this.settings(this.getParams())
          }
          this.$message.success('答卷回收渠道保存成功!')
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    getParams() {
      let params = {
        id: GlobalConfig.getSurveyId(),
        otherSetting: {
          enableNetManualAudit: this.surveyFlag,
          enableAuditForRedEnvelopes: this.auditRadio === 'enableAuditForRedEnvelopes',
          auditForRedEnvelopesAutoPassTime: this.auditRadio === 'enableAuditForRedEnvelopes' ? this.deadlineRed : this.deadlineAll
        }
      }
      return params
    },
    // 底部的两个更新按钮
    saveSetting() {
      // 多级审核设置
      let audits = this.examineTables
      let flag = this.examineTables.some(item => item.auditors.length === 0)
      if (flag) {
        let h = this.$createElement
        let message = ''
        if (audits.length > 1) {
          message = h('p', [
            h('span', { class: 'text-red' }, '存在审核层级未添加审核员的情况'),
            h('span', '，请添加审核员或删除无用层级')
          ])
          this.warnMessage(message)
          return false
        } else {
          this.singleReview()
          this.saveAudit()
          // return
          // this.saveAudit()
          // message = h('p', [h('span', { class: 'text-red' }, '尚未添加审核员'), h('span', '，请添加审核员')])
        }
        // this.warnMessage(message)
        // return
      } else {
        this.saveAudit()
      }
      this.handlerpeopleExamine()
      // 关闭抽屉
      this.$emit('close')
    },
    saveAudit() {
      let audits = this.examineTables
      overwriteLevels(this.surveyId, audits).then(res => {
        this.$message.success('层级审核更新成功')
        if (this.isAddLevel) {
          fixTask(this.surveyId)
          this.isAddLevel = false
        }
      })
    },
    // 提示警告信息
    warnMessage(message) {
      this.$msgbox({
        title: '更新失败',
        message,
        confirmButtonText: '确定',
        type: 'error'
      })
    },
    // 触发网络调查开关
    handlerSurveyFlag(val) {
      if (!val) this.radio = 0
    },
    // 关闭抽屉的回调
    closeManualReview() {
      overwriteLevels(this.surveyId, this.examineTablesCopy)
      this.$emit('close')
    },
    // 开启单级审核
    singleReview() {
      this.radio = 0
      this.examineTables = []
    },
    // 开启多级审核
    onClickOpenAudit() {
      this.radio = 1
      this.addAudit().then(res => {
        this.showOperaAudit = true
      })
    },
    // 添加审核层级
    onClickAddLevel() {
      this.isAddLevel = true
      this.addAudit()
    },
    addAudit() {
      return new Promise(resolve => {
        this.examineTables.push(this.getExamineTableItem(null, []))
        resolve()
      })
    },
    // 获取调研工厂用户
    getDygcUser() {
      getDygcAllUser().then(data => {
        this.companyUser = data
        this.disabledAddUserBtn = false
      })
    },
    getExamineTableItem(levelId, auditors = []) {
      let isCustomId = false
      if (!levelId) {
        let d = Date.now().toString()
        levelId = d.substr(d.length - 10) + '' + (Math.random() * 10000).toFixed(0)
        isCustomId = true
      }
      return {
        levelId,
        auditors,
        isCustomId
      }
    },
    transformLevels(data = [], str) {
      this.examineTables = data.map((item, index) => {
        return this.getExamineTableItem(
          item.levelId,
          item.auditors.map((item, index) => {
            item.index = index + 1
            return item
          })
        )
      })
      if (!str) {
        this.examineTablesCopy = deepClone(this.examineTables)
      }
    },
    getAudit(str) {
      let load = transformLoadingFunction('正在获取数据')
      return getAudit(this.surveyId)
        .then(res => {
          let data = res.data.data
          if (!data.length) {
            load.close()
          } else {
            this.radio = 1
            this.transformLevels(data, str)
            load.close()
          }
        })
        .catch(() => load.close())
    },
    // 删除审核层级
    onClickDelAudit(item, index) {
      this.$confirm('删除操作不可恢复，确认要删除吗？', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('删除成功')
        this.examineTables.splice(index, 1)
      })
    },
    //添加操作人员
    onClickAddUser(item, index) {
      this.currentLevelId = item.levelId
      // 该账号是子账号的话，设置隐藏电话的字段
      item.auditors.forEach(item => {
        if (item.mobile) {
          item.staffType = 1
        } else {
          item.staffType = 2
        }
      })
      this.currentLevelAuditors = item.auditors
      this.AddAuditDialogVisible = true
    },
    // 删除操作人员
    onClickDelUser(item, user, index) {
      let auditors = item.auditors
      let idx = auditors.findIndex(i => i.id === user.id)
      let _auditors = auditors.slice()
      if (!item.isCustomId) {
        if (idx > -1) {
          _auditors.splice(idx, 1)
          setAudit({
            id: this.surveyId,
            auditors: _auditors,
            levelId: item.levelId
          }).then(res => {
            item.auditors = _auditors
          })
        }
      } else {
        auditors.splice(idx, 1)
      }
    },
    // 弹出框的添加操作
    confirmHandler(selects) {
      let companyId = this.companyId
      const auditors = selects.map((item, index) => {
        return {
          id: item.id,
          customerId: item.customerId,
          companyId,
          allowModifyAnswers: item.allowModifyAnswers,
          status: 2,
          index: index + 1,
          name: item.name,
          mobile: item.mobile
        }
      })
      let find = this.examineTables.find(item => item.levelId === this.currentLevelId)
      if (this.currentLevelId && !find.isCustomId) {
        return setAudit({
          id: this.surveyId,
          levelId: this.currentLevelId,
          auditors: selects.map(item => {
            return {
              id: item.id,
              customerId: item.customerId,
              companyId,
              allowModifyAnswers: item.allowModifyAnswers
            }
          })
        }).then(() => {
          this.getAudit('add-handlers')
        })
      } else {
        return new Promise(resolve => {
          find.auditors = auditors
          resolve()
        })
      }
    }
  },
  created() {
    this.surveyId = GlobalConfig.getSurveyId()
    this.companyId = Number(GlobalConfig.getCompanyId())
    // 获取审核层级信息
    this.getAudit()
    // 获取调研工厂用户
    this.getDygcUser()
    this.deadlineRed = this.deadlineR
    this.deadlineAll = this.deadlineA
    this.auditRadio = this.auditRa
    if (this.agentInt) {
      this.surveyFlag = this.peopleExamine
    }
  },
  watch: {
    deadlineR(n) {
      this.deadlineRed = n
    },
    deadlineA(n) {
      this.deadlineAll = n
    },
    auditRa(n) {
      this.auditRadio = n
    },
    peopleExa(n) {
      this.peopleExamine = n
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: rgba($color: #000000, $alpha: 0.65);
}
</style>
